import Api from '.';

class ReportApi extends Api {
  base_endpoint = 'reports';

  getWidgetData(widget, params) {
    return this.doRequest('get', `${widget.report_id}/widgets/${widget.id}/data`, { params });
  }
}

export default new ReportApi();
